let navigationMenu = {
    isOpen: false,
    bodyLockedClass: '.locked',
    pageWrapper: '#wrapper',
    wrapperOverlay: '.wrapper-overlay',
    navWrapper: '.menu',
    mobileNavActiveClass: '.open',
    navigationElement: 'nav.navigation',
    mobileMenuToggleCheckbox: '#mobile-menu-toggle',
    mobileMenuToggleTrigger: '#mobile-menu-toggle-trigger',
    subNavClass: '.has-sub-nav',
    activeSubNavClass: '.show-sub',
    subNavMarker: '<div class="sub-toggle"></div>',
    dropdownContent: '.dropdown-content',
    mobileBreakpoint: 991,
    clickHandler: 'click',

    init: function() {
        $(this.navigationElement + ' li:has(ul.dropdown-content)')
            .addClassName(this.subNavClass)
            .prepend(this.subNavMarker);

        if ('ontouchstart' in document.documentElement) {
            this.clickHandler = 'touchend';
        }

        this.addEventListeners(this.clickHandler);
        this.enableMobileMenuIfRequired();
    },

    toggleMenuVisibility: function() {
        $(this.pageWrapper + ', ' + this.navWrapper + ', body, ' + this.wrapperOverlay).toggleClassName(this.mobileNavActiveClass);
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
            this.lockPage();
        } else {
            this.unlockPage();
        }
    },

    showSubMenus: function(el) {
        $(this.dropdownContent + ' ul').each(function() {
            if (!$(this).hasClass('keep-open')) {
                $(this).collapse('hide');
            } else {
                $(this).collapse('show');
            }
        });
        $(this.dropdownContent + ' .keep-open.menu-section-heading[data-toggle="collapse"]').addClassName('active');
        el.parent().addClassName('active');
        $(this.navigationElement + ' > .container').addClassName(this.activeSubNavClass);
    },

    hideSubMenus: function() {
        $(this.navigationElement + ' > .container').removeClassName(this.activeSubNavClass);
        $(this.subNavClass).removeClassName('active');
    },

    toggleCollapsibleSections: function(el) {
        if (!el.hasClass('active')) {
            $(this.dropdownContent + ' .menu-section-heading[data-toggle="collapse"]').removeClass('active');
            el.addClass('active');
        } else {
            $(this.dropdownContent + ' .menu-section-heading[data-toggle="collapse"]').not(this).removeClass('active');
            el.removeClass('active');
        }

        $(this.dropdownContent + ' ul.collapse').collapse('hide');
        el.siblings('ul.collapse').collapse('toggle');

    },

    enableCollapsibleDropdownContent: function() {
        $(this.dropdownContent + ' ul:not(.keep-open)').collapse();
        $(this.dropdownContent + ' .menu-section-heading').attr('data-toggle', 'collapse');
        $(this.dropdownContent + ' ul.collapsing').collapse('hide');

        $(document).on('click', this.dropdownContent + ' .menu-section-heading[data-toggle="collapse"]', function() {
            navigationMenu.toggleCollapsibleSections($(this));
        });
    },

    disableCollapsibleDropdownContent: function() {
        $(this.dropdownContent + ' ul.collapse').collapse('show');
        $(this.dropdownContent + ' ul').removeClass('collapse').removeClass('in');
        $(this.dropdownContent + ' .menu-section-heading').removeAttr('data-toggle');
    },

    enableMobileMenuIfRequired: function() {
        if (window.innerWidth > this.mobileBreakpoint) {
            this.disableCollapsibleDropdownContent();
        } else {
            this.enableCollapsibleDropdownContent();
        }
    },

    lockPage: function() {
        $(this.wrapperOverlay).bind('touchmove', function(e) {
            e.preventDefault();
        });

        if (window.innerWidth < this.mobileBreakpoint) {
            $(this.pageWrapper).css('top', '-' + document.body.scrollTop + 'px');
        }

        $('body').addClassName(this.bodyLockedClass);
    },

    unlockPage: function() {
        let scrollTop = $(this.pageWrapper).css('top');
        $('body').removeClassName(this.bodyLockedClass);
        $(this.wrapperOverlay).unbind('touchmove');
        $(this.pageWrapper).attr('style', '');

        if (window.innerWidth < this.mobileBreakpoint) {
            window.scrollTo(0, scrollTop.replace(/[A-Za-z$-]/g, ''));
        }
    },

    addEventListeners: function(clickHandler) {
        $(document).on('click', this.mobileMenuToggleTrigger, function() {
            navigationMenu.toggleMenuVisibility();
        });

        $(document).on(clickHandler, this.pageWrapper + this.mobileNavActiveClass, function() {
            navigationMenu.toggleMenuVisibility();
            $(navigationMenu.mobileMenuToggleCheckbox).prop('checked', !$(navigationMenu.mobileMenuToggleCheckbox).prop('checked'));
        });

        $(this.subNavClass + ' > a').on(clickHandler, function() {
            navigationMenu.showSubMenus($(this));
        });

        $(this.subNavClass + ' .back').on(clickHandler, function() {
            navigationMenu.hideSubMenus();
        });

        $(document).on(clickHandler, 'header.mobile a[data-lock-on-open]', function() {
            navigationMenu.lockPage();
        });

        $(document).on('click', '.mobile-overlay a.close', function() {
            navigationMenu.unlockPage();
        });
    },

    replaceDotForClassName: function(className) {
        return className.replace('.', '');
    }
};

window.addEventListener('resize', function() {
    if (window.innerWidth > navigationMenu.mobileBreakpoint) {
        $(navigationMenu.pageWrapper + ', ' + navigationMenu.navWrapper + ', body, ' + navigationMenu.wrapperOverlay).removeClassName(navigationMenu.mobileNavActiveClass);
        $(navigationMenu.mobileMenuToggleCheckbox).prop('checked', false);
        navigationMenu.disableCollapsibleDropdownContent();
        navigationMenu.hideSubMenus();
        navigationMenu.unlockPage();
    } else {
        navigationMenu.enableCollapsibleDropdownContent();
    }
});

$.fn.addClassName = function(className) {
    return this.addClass(navigationMenu.replaceDotForClassName(className));
};

$.fn.removeClassName = function(className) {
    return this.removeClass(navigationMenu.replaceDotForClassName(className));
};

$.fn.toggleClassName = function(className) {
    return this.toggleClass(navigationMenu.replaceDotForClassName(className));
};
